import { ProjectMilestoneStatus } from "@/enums";
import { IMilestone } from "@/interfaces";

export const calculateCanEditMilestoneTargetDates = (
  { status, targetDateLocked }: IMilestone,
  canUserModifyProject: boolean,
  isProjectComplete: boolean
): boolean => {
  if (canUserModifyProject && !isProjectComplete) {
    return (
      status !== ProjectMilestoneStatus.Approved &&
      status !== ProjectMilestoneStatus.InApproval &&
      status !== ProjectMilestoneStatus.Released &&
      status !== ProjectMilestoneStatus.Skipped
    );
  }
  return false;
};

export const calculateCanEditMilestoneActualDate = (
  { status, targetDateLocked }: IMilestone,
  canUserModifyProject: boolean,
  isProjectComplete: boolean
): boolean => {
  if (canUserModifyProject && !isProjectComplete) {
    return true;
  }
  return false;
};
